module.exports = __webpack_public_path__ + "static/img/mingshi2.8fa1bb92.png";